import { Phone, MapPin, Home, TreePine, Leaf, Clock } from "lucide-react";
import { COMPANY } from "./constants";

export default function HeroSection({ onOpenModal }) {
  return (
    <section
      data-testid="hero-section"
      className="hero-section min-h-screen flex items-center justify-center relative"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1558904541-efa843a96f01?q=80&w=2070&auto=format&fit=crop')`
      }}
    >
      <div className="hero-overlay"></div>

      <nav className="absolute top-0 left-0 right-0 z-30 px-4 sm:px-8 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Leaf className="w-8 h-8 text-forest-200" />
            <span className="font-serif text-xl sm:text-2xl text-white font-bold tracking-wide">
              {COMPANY.name}
            </span>
          </div>
          <div className="hidden md:flex items-center gap-6">
            <a
              href={COMPANY.phoneLink}
              data-testid="header-phone-link"
              className="flex items-center gap-2 text-white hover:text-forest-200 transition-colors relative phone-pulse"
            >
              <Phone className="w-5 h-5" />
              <span className="font-medium">{COMPANY.phone}</span>
            </a>
            <div className="flex items-center gap-1 bg-forest-500/80 text-white px-3 py-1 rounded-full text-sm badge-24-7">
              <Clock className="w-4 h-4" />
              <span>24/7</span>
            </div>
          </div>
        </div>
      </nav>

      <div className="hero-content text-center px-4 sm:px-8 max-w-4xl mx-auto">
        <h1
          data-testid="hero-title"
          className="font-serif text-4xl sm:text-5xl lg:text-7xl text-white font-bold mb-6 animate-fade-in-up"
        >
          Transform Your
          <span className="block text-forest-200">Outdoor Space</span>
        </h1>
        <p
          data-testid="hero-subtitle"
          className="text-lg sm:text-xl text-white/90 mb-4 max-w-2xl mx-auto animate-fade-in-up delay-100"
        >
          Professional landscape services for residential and commercial properties in Middle Georgia
        </p>
        <p className="text-sand-400 text-base mb-10 flex items-center justify-center gap-2 animate-fade-in-up delay-200">
          <MapPin className="w-5 h-5" />
          {COMPANY.area}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center animate-fade-in-up delay-300">
          <button
            data-testid="residential-btn"
            onClick={() => onOpenModal('residential')}
            className="glass-button rounded-full px-10 py-5 text-xl text-white font-serif tracking-wide flex items-center justify-center gap-3"
          >
            <Home className="w-6 h-6" />
            Residential
          </button>
          <button
            data-testid="commercial-btn"
            onClick={() => onOpenModal('commercial')}
            className="glass-button rounded-full px-10 py-5 text-xl text-white font-serif tracking-wide flex items-center justify-center gap-3"
          >
            <TreePine className="w-6 h-6" />
            Commercial
          </button>
        </div>

        <div className="mt-10 md:hidden animate-fade-in-up delay-400">
          <a
            href={COMPANY.phoneLink}
            data-testid="mobile-phone-link"
            className="inline-flex items-center gap-2 bg-forest-500 text-white px-6 py-3 rounded-full font-medium hover:bg-forest-600 transition-colors"
          >
            <Phone className="w-5 h-5" />
            Call Now - 24/7 Support
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
